module.exports = __webpack_public_path__ + "img/p7.6bf688a7.png";